import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaymentsCard from '../../../../components/ui/PaymentsCard/PaymentsCard';
import FlatMeters from './components/FlatMeters';
import FlatDocuments from './components/FlatDocuments';
import FlatTenants from './components/FlatTenants';
import FlatRelatedObjects from './components/FlatRelatedObjects';
import {
  setAvailableFlat,
  setCurrentFlat,
} from '../../../../store/actions/housingStockActions';
import styles from './Flat.module.scss';
import FlatAccountsPersone from './components/FlatAccountsPersone';
import FlatRoomStage from './components/FlatRoomStage';
import FlatComments from './components/FlatComments/FlatComments';
import useFlatAvailable from '../../../../queries/useFlatAvailable';
import { useRouteMatch } from 'react-router-dom';
import NotAccess from '../NotAccess/NotAccess';
import FlatRoomDdy from './components/FlatRoomDdy';

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

const Flat = () => {
  const dispatch = useDispatch();

  const { isAvailable } =
    useSelector((state) => state.housingStockStore.flatAvailable) || {};

  const { params } = useRouteMatch();

  const houseId = useMemo(() => getId(params.pageId), [params.pageId]);
  const flatId = useMemo(() => getId(params.pageTabId), [params.pageTabId]);

  const { data: isAvailableFlat, isFetching } = useFlatAvailable({
    flatId,
    houseId,
  });

  useEffect(() => {
    return () => {
      dispatch(setCurrentFlat(null));
      dispatch(setAvailableFlat(null));
    };
  }, []);

  const blocks = [
    {
      gridArea: 'accounts',
      content: (
        <div className={styles.col}>
          <FlatRoomStage />
          <FlatRoomDdy />
          <FlatAccountsPersone />
        </div>
      ),
    },
    { gridArea: 'relatedObjects', content: <FlatRelatedObjects /> },
    { gridArea: 'docs', content: <FlatDocuments /> },
    { gridArea: 'comment', content: <FlatComments /> },
    { gridArea: 'meters', content: <FlatMeters /> },
    {
      gridArea: 'payments',
      content: (
        <PaymentsCard
          className={styles.grow}
          disabled
        />
      ),
    },
  ];

  useEffect(() => {
    dispatch(
      setAvailableFlat({
        flatId,
        isAvailable: !isAvailableFlat ? false : isAvailableFlat.isAvailable,
      })
    );
  }, [dispatch, flatId, isAvailableFlat]);

  if (!isAvailable && !isFetching) return <NotAccess />;

  return (
    <div className={styles.root}>
      <div
        className={styles.blockWrapper}
        style={{ position: 'relative' }}
      >
        <FlatTenants />
      </div>
      <div className={styles.rightSide}>
        {blocks.map((block) => (
          <div
            className={styles.blockWrapper}
            key={block.gridArea}
            style={{ gridArea: block.gridArea }}
          >
            {block.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Flat;
